import React, { useEffect, useState } from "react";
import {
  Card,
  Form,
  InputGroup,
  Button,
  Breadcrumb,
  Pagination,
} from "react-bootstrap";
import { Icon } from "@iconify/react";
import UploadImageComponent from "../../components/UploadImageComponent";
import InputLeftIcon from "../../components/form_item/InputLeftIcon";
import { SuccessSwal, WarningSwal } from "../../helpers/alertseet";
import { useNavigate, useParams } from "react-router-dom";
import { useStore } from "../../store";
import { get_member, update_member } from "../../services/membership.service";
import moment from "moment";
import { END_IMAGE } from "../../constants";
import convertNumberReverse from "../../helpers/convertNumberReverse";
import cutBranchNo from "../../helpers/cutBranchNo";

export default function UpdateMembershipPage() {
  const navigate = useNavigate();
  const { membershipId } = useParams();
  // state
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [validate, setValidate] = useState({
    firstName: false,
    lastName: false,
    birthday: false,
    occupation: false,
    phone: false,
    gender: false,
    userName: false,
    password: false,
    // role: false,
    personalID: false,
    familyNumber: false,
    homeNumber: false,
    homeUnit: false,
    village: false,
    district: false,
    province: false,
  });
  // store
  const { token, setIsLoadingDetailPage } = useStore();

  // useEffect
  useEffect(() => {
    getData();
  }, []);

  // function
  const checkValidate = () => {
    let _validate = {};
    let state = false;
    if (!formData?.firstName) {
      _validate.firstName = true;
      state = true;
    }
    if (!formData?.lastName) {
      _validate.lastName = true;
      state = true;
    }
    if (!formData?.birthday) {
      _validate.birthday = true;
      state = true;
    }
    if (!formData?.occupation) {
      _validate.occupation = true;
      state = true;
    }
    if (!formData?.phone) {
      _validate.phone = true;
      state = true;
    }
    if (!formData?.gender) {
      _validate.gender = true;
      state = true;
    }
    if (!formData?.familyNumber) {
      _validate.familyNumber = true;
      state = true;
    }
    if (!formData?.homeNumber) {
      _validate.homeNumber = true;
      state = true;
    }
    if (!formData?.homeUnit) {
      _validate.homeUnit = true;
      state = true;
    }

    if (!formData?.incomeActivity) {
      _validate.incomeActivity = true;
      state = true;
    }
    if (!formData?.district) {
      _validate.district = true;
      state = true;
    }
    if (!formData?.province) {
      _validate.province = true;
      state = true;
    }

    // if (!formData?.branchID) {
    //   _validate.branchID = true;
    //   state = true;
    // }

    setValidate(_validate);
    return state;
  };
  const getData = async () => {
    try {
      setIsLoading(true);
      setIsLoadingDetailPage(true);
      const data = await get_member(membershipId, token);
      if (data?.error) throw new Error(data?.message);
      let member = data?.data;
      member.birthday = moment(member.birthday).format("YYYY-MM-DD");

      setFormData(member);
      setIsLoading(false);
      setIsLoadingDetailPage(false);
    } catch (err) {
      console.error("error", err);
      setIsLoading(false);
      setIsLoadingDetailPage(false);
    }
  };
  const handleUpdateMembership = async () => {
    try {
      if (isLoading) {
        WarningSwal("ກະລຸນາລໍຖ້າ");
        return;
      }
      setIsLoading(true);
      const stateCheck = checkValidate();
      if (stateCheck) throw new Error("validate");

      const data = await update_member(membershipId, formData, token);
      if (data?.error) {
        throw new Error(data?.message);
      }

      setIsLoading(false);
      SuccessSwal("ສ້າງບັນຊີສຳເລັດ!");
      navigate("/membership", { replace: true });
    } catch (err) {
      console.error(err);
      setIsLoading(false);
    }
  };
  return (
    <div>
      <Breadcrumb>
        <Breadcrumb.Item
          onClick={() => navigate("/membership", { replace: true })}
        >
          ບັນຊີສະມາຊິກ
        </Breadcrumb.Item>
        <Breadcrumb.Item active>ແກ້ໄຂບັນຊີ</Breadcrumb.Item>
      </Breadcrumb>
      <Card
        style={{
          padding: "20px 20px",
          minHeight: "80dvh",
          position: "relative",
          paddingBottom: 150,
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "auto 1fr",
            gap: 20,
            gridGap: 20,
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
            <h2>ຮູບພາບ</h2>
            <div>
              <UploadImageComponent
                src={
                  formData?.profileImage
                    ? END_IMAGE + formData?.profileImage
                    : ""
                }
                style={{ width: 160, height: 160, objectFit: "cover" }}
                onChange={(image) =>
                  setFormData((prev) => ({
                    ...prev,
                    profileImage: image,
                  }))
                }
              />
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
            <h2>ຂໍ້ມູນສ່ວນໂຕ</h2>
            <div>
              <Form.Label>ເລກສະມາຊິກ</Form.Label>
              <InputLeftIcon
                icon={
                  <Icon icon="tabler:id" style={{ width: 24, height: 24 }} />
                }
                disabled
                placeholder="ກະລຸນາປ້ອນຂໍ້ມູນ..."
                isInvalid={validate?.memberNo}
                value={
                  formData?.memberNo ? cutBranchNo(formData?.memberNo) : "-"
                }
                // onChange={(e) =>
                //   setFormData((prev) => ({
                //     ...prev,
                //     memberNo: e.target.value,
                //   }))
                // }
              />
            </div>
            <div>
              <Form.Label>ຊື່</Form.Label>
              <InputLeftIcon
                icon={
                  <Icon
                    icon="material-symbols:person-outline"
                    style={{ width: 24, height: 24 }}
                  />
                }
                placeholder="ກະລຸນາປ້ອນຂໍ້ມູນ..."
                isInvalid={validate?.firstName}
                value={formData?.firstName}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    firstName: e.target.value,
                  }))
                }
              />
            </div>
            <div>
              <Form.Label>ນາມສະກຸນ</Form.Label>
              <InputLeftIcon
                icon={
                  <Icon
                    icon="material-symbols:person-outline"
                    style={{ width: 24, height: 24 }}
                  />
                }
                placeholder="ກະລຸນາປ້ອນຂໍ້ມູນ..."
                isInvalid={validate?.lastName}
                value={formData?.lastName}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    lastName: e.target.value,
                  }))
                }
              />
            </div>
            <div>
              <Form.Label>ເພດ</Form.Label>
              <div style={{ display: "flex", gap: 20 }}>
                <Form.Check
                  type="radio"
                  label={`ຊາຍ`}
                  name="sex"
                  id="radio-sex-m"
                  isInvalid={validate?.gender}
                  value="MALE"
                  checked={formData?.gender === "MALE"}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      gender: e.target.value,
                    }))
                  }
                />
                <Form.Check
                  type="radio"
                  label={`ຍິງ`}
                  name="sex"
                  id="radio-sex-f"
                  isInvalid={validate?.gender}
                  value="FEMALE"
                  checked={formData?.gender === "FEMALE"}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      gender: e.target.value,
                    }))
                  }
                />
              </div>
            </div>
            <div>
              <Form.Label>ວັນເດືອນປີເກີດ</Form.Label>
              <InputLeftIcon
                icon={
                  <Icon
                    icon="uil:user-plus"
                    style={{ width: 24, height: 24 }}
                  />
                }
                type="date"
                placeholder="ວັນເດືອນປີເກີດ"
                isInvalid={validate?.birthday}
                value={formData?.birthday}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    birthday: e.target.value,
                  }))
                }
              />
            </div>
            <div>
              <Form.Label>ອາຊີບ</Form.Label>
              <InputLeftIcon
                icon={
                  <Icon
                    icon="uil:suitcase-alt"
                    style={{ width: 24, height: 24 }}
                  />
                }
                placeholder="ປ້ອນອາຊີບ"
                isInvalid={validate?.occupation}
                value={formData?.occupation}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    occupation: e.target.value,
                  }))
                }
              />
            </div>
            <div>
              <Form.Label>ໜ່ວຍ</Form.Label>
              <InputLeftIcon
                icon={
                  <Icon
                    icon="material-symbols:cottage-outline-rounded"
                    style={{ width: 24, height: 24 }}
                  />
                }
                placeholder="ປ້ອນໜ່ວຍ"
                isInvalid={validate?.homeUnit}
                value={formData?.homeUnit}
                onChange={(e) => {
                  convertNumberReverse(e?.target?.value, (value) => {
                    setFormData((prev) => ({
                      ...prev,
                      homeUnit: value,
                    }));
                  });
                }}
              />
            </div>

            <div>
              <Form.Label>ເຮືອນເລກທີ</Form.Label>
              <InputLeftIcon
                icon={
                  <Icon
                    icon="material-symbols:cottage-outline-rounded"
                    style={{ width: 24, height: 24 }}
                  />
                }
                placeholder="ປ້ອນເຮືອນເລກທີ"
                isInvalid={validate?.homeNumber}
                value={formData?.homeNumber}
                onChange={(e) => {
                  convertNumberReverse(e?.target?.value, (value) => {
                    setFormData((prev) => ({
                      ...prev,
                      homeNumber: value,
                    }));
                  });
                }}
              />
            </div>
            <div>
              <Form.Label>ບ້ານ</Form.Label>
              <InputLeftIcon
                icon={
                  <Icon
                    icon="uil:location-point"
                    style={{ width: 24, height: 24 }}
                  />
                }
                disabled
                placeholder="ກະລຸນາປ້ອນຂໍ້ມູນ..."
                isInvalid={validate?.village}
                value={formData?.village}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    village: e.target.value,
                  }))
                }
              />
            </div>
            <div>
              <Form.Label>ເມືອງ</Form.Label>
              <InputLeftIcon
                icon={
                  <Icon
                    icon="uil:location-point"
                    style={{ width: 24, height: 24 }}
                  />
                }
                disabled
                placeholder="ກະລຸນາປ້ອນຂໍ້ມູນ..."
                isInvalid={validate?.district}
                value={formData?.district}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    district: e.target.value,
                  }))
                }
              />
            </div>
            <div>
              <Form.Label>ແຂວງ</Form.Label>
              <InputLeftIcon
                icon={
                  <Icon
                    icon="uil:location-point"
                    style={{ width: 24, height: 24 }}
                  />
                }
                disabled
                placeholder="ກະລຸນາປ້ອນຂໍ້ມູນ..."
                isInvalid={validate?.province}
                value={formData?.province}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    province: e.target.value,
                  }))
                }
              />
            </div>
            <div>
              <Form.Label>ສຳມະໂນຄົວເລກທີ</Form.Label>
              <InputLeftIcon
                icon={
                  <Icon
                    icon="uil:files-landscapes-alt"
                    style={{ width: 24, height: 24 }}
                  />
                }
                placeholder="ປ້ອນເລກສຳມະໂນຄົວ"
                isInvalid={validate?.familyNumber}
                value={formData?.familyNumber}
                onChange={(e) => {
                  convertNumberReverse(e?.target?.value, (value) => {
                    setFormData((prev) => ({
                      ...prev,
                      familyNumber: value,
                    }));
                  });
                }}
              />
            </div>
            {/* <div>
              <Form.Label>ລົງວັນທີ</Form.Label>
              <InputLeftIcon
                icon={
                  <Icon
                    icon="uil:calendar-alt"
                    style={{ width: 24, height: 24 }}
                  />
                }
                placeholder="ເລືອກວັນທີ"
              />
            </div> */}
            <div>
              <Form.Label>ກິດຈະກຳສ້າງລາຍຮັບ</Form.Label>
              <InputLeftIcon
                icon={
                  <Icon
                    icon="uil:money-bill"
                    style={{ width: 24, height: 24 }}
                  />
                }
                placeholder="ປ້ອນແຫຼ່ງສ້າງລາຍຮັບ"
                isInvalid={validate?.incomeActivity}
                value={formData?.incomeActivity}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    incomeActivity: e.target.value,
                  }))
                }
              />
            </div>
            <div>
              <Form.Label>ເບີໂທ</Form.Label>
              <InputLeftIcon
                icon={
                  <Icon
                    icon="uil:phone-alt"
                    style={{ width: 24, height: 24 }}
                  />
                }
                placeholder="ປ້ອນເບີໂທ"
                isInvalid={validate?.phone}
                value={formData?.phone}
                onChange={(e) => {
                  convertNumberReverse(e?.target?.value, (value) => {
                    setFormData((prev) => ({
                      ...prev,
                      phone: value,
                    }));
                  });
                }}
              />
            </div>
          </div>
        </div>
        <br />
        <br />
        <div style={{ display: "flex", gap: 20, justifyContent: "flex-end" }}>
          <Button
            variant="outline-primary"
            size="md"
            disabled={isLoading}
            onClick={() => {
              navigate("/membership", { replace: true });
            }}
          >
            ຍົກເລີກ
          </Button>
          <Button
            disabled={isLoading}
            onClick={handleUpdateMembership}
            size="md"
          >
            ບັນທຶກ
          </Button>
        </div>
      </Card>
    </div>
  );
}
